import React from 'react';
import AirbnbIcon from "@assets/svg/airbnb.svg?react";
import GathernIcon from "@assets/svg/gathren.svg?react";
import BookingIcon from "@assets/svg/BookingLogo.svg?react";
import MsoolIcon from "@assets/svg/MsoolIcon.svg?react";

export const getChannelIcon = (channelName: string): React.ReactNode => {
  const normalizedName = channelName.toLowerCase().trim();
  
  switch (normalizedName) {
    case 'airbnb':
      return <AirbnbIcon />;
    case 'booking':
    case 'booking.com':
      return <BookingIcon />;
    case 'gathern':
    case 'gatherin':
      return <GathernIcon />;
    case 'msool':
    case 'direct booking':
    case 'MsoolCommission':
      return <MsoolIcon />;
    default:
      // Return a default icon or the first letter of the channel name
      return (
        <div style={{ 
          width: '24px', 
          height: '24px', 
          borderRadius: '50%', 
          backgroundColor: '#5B3FFF', 
          color: 'white', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          fontSize: '12px', 
          fontWeight: 'bold' 
        }}>
          {channelName.charAt(0).toUpperCase()}
        </div>
      );
  }
};

export const getChannelDisplayName = (channelName: string): string => {
  const normalizedName = channelName.toLowerCase().trim();
  
  switch (normalizedName) {
    case 'airbnb':
      return 'Airbnb';
    case 'booking':
    case 'booking.com':
      return 'Booking.com';
    case 'gathern':
    case 'gatherin':
      return 'Gathern';
    case 'msool':
      return 'Msool';
    default:
      return channelName;
  }
};
